import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

import { HOST_WEB_PRODUCTION, HOST_WEB_STAGING } from 'utils/constants';

import Button from 'components/Button';
import Column from 'components/Column';
import Container from 'components/Container';
import ContentAd from 'components/Content/ContentAd';
import Footer from 'components/Footer';
import H2 from 'components/H2';
import Img from 'components/Img';
import P from 'components/P';
import PAd from 'components/P/PAd';
import PSmall from 'components/PSmall';

import messages from './messages';

import KalkulatorIcon from './images/kalkulator-icon.svg';

const ContainerAd = styled(Container)`
  min-height: 0;
  padding-top: 0;
  height: 310px;
  background-color: #ffffff;

  @media (max-width: 420px) {
    width: 100%;
  }
`;

const Title = styled(H2)`
  margin: 0;

  @media(max-width: 420px) {
    font-size: 20px;
  }
`

function onClickCTA(props) {
  const HOST = process.env.PREACT_APP_API_URL === 'production' ? HOST_WEB_PRODUCTION : HOST_WEB_STAGING;
  const cohort = props.matches.cohort;
  return HOST + '/partner/klinik/?service=kalkulator-waris&utm_source=klinik&utm_medium=web&utm_campaign=banner&utm_content=kalkulator&cohort=' + cohort;
}

// Note: `user` comes from the URL, courtesy of our router
const WarisCalculator = (props) => {
  return (
    <ContainerAd>
      <ContentAd>
        <Column width={1}>
          <Title>
            <FormattedMessage {...messages.header} /><br />
            <FormattedMessage {...messages.header_precisely} />
          </Title>
        </Column>
        <PAd style={{ color: '#000', margin: '4px 0 0' }}>
          <FormattedMessage {...messages.description} />
        </PAd>
        <Column width={1}>
          <Img
            style={{ width: '50px', height: '50px' }}
            src={KalkulatorIcon}
            alt="Kalkulator Icon"
          />
        </Column>
        <Column style={{ marginTop: 0, marginBottom: 0 }}>
          <P style={{ color: '#003366', fontWeight: 600, marginTop: 0, marginBottom: 0 }}>{"Gratis"}</P>
        </Column>
        <Column width="2" style={{ margin: '0' }}>
          <Button
            href={onClickCTA(props)}
            blank="_blank"
            color="yellow"
            size="large"
          >
            <FormattedMessage {...messages.cta} />
          </Button>
        </Column>
        <br />
        <Footer />
      </ContentAd>
    </ContainerAd>
  );
}

export default WarisCalculator;